<template>
  <div>
    <v-container fluid grid-list-md class="padding_10">
      <v-layout row wrap style="padding: 0px 0px 0px 0px; align-content: center; align-items: center;">
        <v-flex xm12 sm12 md12 lg12 style="display: flex">
          <v-flex xm12 sm12 md12 lg12>
            <v-tabs
                v-model="tabSelection"
                fixed-tabs
                centered
                color="cyan"
                dark
                icons-and-text>
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#Metro" class="white--text">
                Metro
                <v-icon>train</v-icon>
              </v-tab>

              <v-tab href="#Bus" class="white--text">
                Bus
                <v-icon>directions_bus</v-icon>
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabSelection" class="white elevation-1">
              <v-tab-item
                  v-for="item in items"
                  :key="item"
                  :value="item.value"
              >
                <v-card>
                  <v-card-text>
                    <v-layout row wrap class="table_opacity_8">
                      <v-flex xm12 sm12 md12 lg12>
                        <v-card style="padding: 30px 0px 30px 0px;">
                          <v-card-title class="headline justify-space-between pb-0"
                                        style="margin-bottom: 20px;">Download {{ tabSelection }} Settlement
                            data
                          </v-card-title>
                          <v-form
                              id="export_details"
                              @submit.prevent="validateBeforeSubmit('exportTransactions')"
                              data-vv-scope="exportTransactions"
                              ref="announcement_form1"
                              v-model="valid"
                          >
                            <v-flex xm12 sm12 md12 lg12 style="display: flex; align-items: center; flex-wrap: wrap;">
                              <v-flex xm12 sm6 md4 lg6>
                                <label>Date: </label>
                                <div style="padding-bottom: 23px !important;">
                                  <flat-pickr
                                      class="flatpickerCSS2"
                                      v-model="transaction_date"
                                      :config="config"
                                      placeholder="Date" v-validate="'required'"
                                      :error-messages="errors.collect('exportTransactions.Relevant from')"
                                      name="Export Transactions"/>
                                </div>
                              </v-flex>

                              <v-flex xm12 sm6 md4 lg6>
                                <label>Select Service Provider: </label>
                                <div>
                                  <v-autocomplete
                                      :items="filteredProviders"
                                      name="Select Service Provider"
                                      label="Select Service Provider"
                                      v-model="service_provider"
                                      item-text="text"
                                      item-value="title"
                                      v-validate="'required'"
                                      solo flat clearable
                                      :error-messages="errors.collect('exportTransactions.Select Service Provider')">
                                  </v-autocomplete>
                                </div>
                              </v-flex>

                              <v-flex xm12 sm12 md12 lg12 style="display: flex; justify-content: flex-end;">
                                <v-btn @click="exportToBeSettledTransactions()"
                                       :disabled="service_provider == '' || service_provider == null">Export
                                  Transactions
                                </v-btn>
                              </v-flex>
                            </v-flex>


                          </v-form>
                        </v-card>
                      </v-flex>

                      <v-flex xm12 sm12 md12 lg12>
                        <v-card style="padding: 30px 0px 30px 0px;">
                          <v-card-title class="headline justify-space-between pb-0" style="margin-bottom: 20px;">Upload
                            file to
                            Update {{ tabSelection }} UTR
                          </v-card-title>

                          <v-form
                              :id="'update_UTR_settlement_' + item.value"
                              @submit.prevent="validateBeforeSubmit('updateUTRSettlement')"
                              data-vv-scope="update_UTR_settlement"
                              ref="update_UTR_settlement"
                              v-model="valid"
                          >
                            <v-card-text>
                              <v-flex xm12 sm12 md12 lg12 style="display: flex; align-items: center;">
                                <input type="file" name="master_data_file" ref="fileupload" required accept="*/*"
                                       :id="'master_data_file_' + item.value"/>
                                <v-flex xs12>
                <span class="red--text" v-if="errors.collect('update_UTR_settlement.master_data_file').length">{{
                    errors.collect('update_UTR_settlement.master_data_file')[0]
                  }}</span>
                                </v-flex>
                              </v-flex>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                              <v-layout justify-end>
                                <v-btn type="submit"
                                       class="mr-3 mb-3"
                                       color="primary"
                                       @click="importSettlementUTRNumber()"
                                >Submit
                                </v-btn>
                              </v-layout>
                            </v-card-actions>
                          </v-form>
                        </v-card>
                      </v-flex>

                      <v-flex xm12 sm12 md12 lg12>
                        <v-card style="padding: 30px 0px 30px 0px;">
                          <v-card-title class="headline justify-space-between pb-0" style="margin-bottom: 20px;">Check
                            UTR and Confirm Recon {{ tabSelection }}
                          </v-card-title>
                          <v-card-text>
                            <v-flex xs12 md12 lg12 style="display: flex; align-items: center;">
                              <v-flex xs4 sm4 md3 lg3>
                                <label>Settlement Reference: </label>
                              </v-flex>

                              <v-flex xs8 sm8 md9 lg9>
                                <v-text-field
                                    label="UTR" box clearable
                                    v-model="confirm_settlement_details.settlement_reference"></v-text-field>
                              </v-flex>
                            </v-flex>
                            <v-flex xs12 md12 lg12 style="display: flex; align-items: center; flex-wrap: wrap"
                                    v-if="show_confirm_amt == 1 && confirm_settlement_amt != 0">
                              <v-flex xs12 md12 lg12 style="display: flex;">
                                <v-flex xs4 sm4 md4 lg4>
                                  <label style="font-weight: bold; font-size: medium">No. of Tickets : </label>
                                </v-flex>

                                <v-flex xs6 sm6 md6 lg6 style="font-size: medium"> {{
                                    confirm_settlement_ticket_no
                                  }}
                                </v-flex>
                              </v-flex>
                              <v-flex xs12 md12 lg12 style="display: flex;">
                                <v-flex xs4 sm4 md4 lg4>
                                  <label style="font-weight: bold; font-size: medium">Confirm Amount : </label>
                                </v-flex>

                                <v-flex xs6 sm6 md6 lg6 style="font-size: medium"> {{ "Rs. " }}{{
                                    confirm_settlement_amt
                                  }}
                                </v-flex>
                              </v-flex>
                            </v-flex>

                            <v-flex xs12 md12 lg12 style="display: flex; align-items: center; flex-wrap: wrap"
                                    v-else-if="no_ticket_dialog == 1 && show_confirm_amt == 1">
                              <h4>No tickets under {{ confirm_settlement_details.settlement_reference }} to be settle or
                                all
                                tickets are already settled</h4>
                            </v-flex>
                          </v-card-text>

                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn v-if="show_confirm_amt == 0" :loading="loaders.settlement_loader"
                                   :disabled="loaders.settlement_loader ||
          confirm_settlement_details.settlement_reference == ''"
                                   color="primary" small @click="confirmSettlement()"> Get Settlement Details
                            </v-btn>

                            <v-btn v-if="show_confirm_amt == 1" :loading="loaders.settlement_loader" :disabled="loaders.settlement_loader ||
          confirm_settlement_details.settlement_reference == ''"
                                   color="primary" small @click="confirm_reconcile_model = true"> Confirm Settlement
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-flex>

                      <v-flex xm12 sm12 md12 lg12>
                        <v-card style="padding: 30px 0px 30px 0px;">
                          <v-card-title class="headline justify-space-between pb-0" style="margin-bottom: 20px;">
                            Download
                            Reconcile Status {{ tabSelection }}
                          </v-card-title>
                          <v-form
                              id="export_reconcile_data"
                              @submit.prevent="validateBeforeSubmit('exportReconcileStatus')"
                              data-vv-scope="exportTransactions"
                              ref="announcement_form1"
                              v-model="valid"
                          >
                            <v-flex xm12 sm12 md12 lg12 style="display: flex; align-items: center; flex-wrap: wrap;">
                              <v-flex xm12 sm6 md4 lg6>
                                <label>Date: </label>
                                <div style="padding-bottom: 23px !important;">
                                  <flat-pickr
                                      class="flatpickerCSS2"
                                      v-model="reconcile_transaction_date"
                                      :config="config"
                                      placeholder="Date" v-validate="'required'"
                                      :error-messages="errors.collect('exportTransactions.Relevant from')"
                                      name="Export Transactions"/>
                                </div>
                              </v-flex>

                              <v-flex xm12 sm12 md12 lg12 style="display: flex; justify-content: flex-end;">
                                <v-btn color="primary" @click="exportReconcileTransactions()"
                                       :disabled="reconcile_transaction_date == ''">Export Transactions
                                </v-btn>
                              </v-flex>
                            </v-flex>
                          </v-form>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-flex>
        </v-flex>

        <v-layout row wrap class="table_opacity_8">
          <v-flex xs12>
            <v-card>
              <v-form
                  id="create_announcement"
                  @submit.prevent="validateBeforeSubmit('createAnnouncement')"
                  data-vv-scope="createAnnouncement"
                  ref="announcement_form"
                  v-model="valid">
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="table_opacity_8">
        </v-layout>


        <!--        <v-flex xs12>-->
        <!--      <v-data-table-->
        <!--          no-results-text="Loading... Please wait"-->
        <!--          :headers="headers"-->
        <!--          v-model="selected"-->
        <!--          :items="ticket_data"-->
        <!--          item-key="id"-->
        <!--          :loading="loaders.ticket_loader"-->
        <!--          :total-items="total_items"-->
        <!--          :rows-per-page-items="[10, 20, 50, 100]"-->
        <!--          class="elevation-1"-->
        <!--          select-all-->
        <!--          :pagination.sync="pagination"-->
        <!--          >-->
        <!--        <template v-slot:items="props">-->
        <!--          <td>-->
        <!--            <v-checkbox-->
        <!--                v-model="props.selected"-->
        <!--                primary-->
        <!--                hide-details-->
        <!--            ></v-checkbox>-->
        <!--          </td>-->
        <!--          <td class="text-xs-left" v-if="props.item">{{ props.item.date }}</td>-->
        <!--          <td v-else> {{ " - " }}</td>-->

        <!--          <td class="text-xs-left" v-if="props.item">{{ props.item.descriptor_name }}</td>-->
        <!--          <td v-else> {{ " - " }}</td>-->

        <!--&lt;!&ndash;          <td class="text-xs-left" v-if="props.item">{{ props.item.descriptor_name }}</td>&ndash;&gt;-->
        <!--&lt;!&ndash;          <td v-else> {{ " - " }}</td>&ndash;&gt;-->

        <!--          <td class="text-xs-left" v-if="props.item.payment_status">{{ props.item.payment_status }}</td>-->
        <!--          <td v-else> {{ " - " }}</td>-->

        <!--          <td class="text-xs-left" v-if="props.item.ticket_status">{{ props.item.ticket_status }}</td>-->
        <!--          <td v-else> {{ " - " }}</td>-->

        <!--          <td class="text-xs-left" v-if="props.item.price">{{ props.item.price }}</td>-->
        <!--          <td v-else> {{ " - " }}</td>-->

        <!--          <td class="text-xs-left" v-if="props.item.cancellation_charge">{{ props.item.cancellation_charge }}</td>-->
        <!--          <td v-else> {{ " - " }}</td>-->

        <!--          <td class="text-xs-left" v-if="props.item.ticket_status">-->
        <!--            <span v-if="props.item.ticket_status == 'CANCELLED'">-->
        <!--              {{ props.item.cancellation_charge }}-->
        <!--            </span>-->
        <!--            <span v-else-if="props.item.ticket_status == 'COMPLETE' || props.item.ticket_status == 'EXPIRED'-->
        <!--            || props.item.ticket_status == 'ACTIVE'">-->
        <!--              {{ props.item.price }}-->
        <!--            </span>-->
        <!--          </td>-->
        <!--          <td v-else> {{ " - " }}</td>-->

        <!--          <td class="text-xs-left" v-if="props.item.settlement_details">{{ props.item.settlement_details.id }}</td>-->
        <!--          <td v-else> {{ " - " }}</td>-->

        <!--          <td class="text-xs-left" v-if="props.item.settlement_details">{{-->
        <!--              props.item.settlement_details.reference_number }}</td>-->
        <!--          <td v-else> {{ " - " }}</td>-->

        <!--          <td class="text-xs-left" v-if="props.item.settlement_details">{{ props.item.reconciliation_id }}</td>-->
        <!--          <td v-else> {{ " - " }}</td>-->

        <!--        </template>-->
        <!--      </v-data-table>-->
        <!--        </v-flex>-->
      </v-layout>

      <v-dialog
          v-model="confirm_reconcile_model"
          scrollable
          :overlay="false"
          max-width="500px"
          max-height="200px"
          transition="dialog-transition"
          persistent
      >
        <v-card>
          <v-form>
            <v-card-title class="headline">Confirm Final Settlement?</v-card-title>
            <v-card-text>
              Are you sure you want to perform the final settlement to the seller? This action cannot be undone.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" @click="callReceiverRecon()">Confirm</v-btn>
              <v-btn
                  small
                  color="black"
                  flat
                  type="reset"
                  @click="confirm_reconcile_model = !confirm_reconcile_model"
              >Cancel
              </v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <!--      <v-dialog v-model="updateSettlementDialog" max-width="700px">-->
      <!--        <v-card>-->
      <!--          <v-form id="update_incident"-->
      <!--                  @submit.prevent="validateBeforeSubmit('updateSettlement')"-->
      <!--                  data-vv-scope="updateSettlement"-->
      <!--                  ref="update_incident_form"-->
      <!--                  v-model="validSettlement">-->

      <!--            <v-card-title style="padding-bottom: 0px;">-->
      <!--              <v-flex xs12 md12 lg12 style="display: flex;justify-content: space-between;">-->
      <!--                <h4 class="heading_text">Update Settlement Details</h4>-->
      <!--                <v-btn icon @click="updateSettlementDialog = false">-->
      <!--                  <v-icon>close</v-icon>-->
      <!--                </v-btn>-->
      <!--              </v-flex>-->
      <!--            </v-card-title>-->
      <!--            <v-card-text>-->
      <!--              <v-layout row wrap>-->
      <!--                <v-flex xs12 md12 lg12 style="display: flex; align-items: center;">-->
      <!--                  <v-flex xs4 sm4 md3 lg3>-->
      <!--                    <label>Settlement Reference: </label>-->
      <!--                  </v-flex>-->

      <!--                  <v-flex xs8 sm8 md9 lg9>-->
      <!--                    <v-text-field-->
      <!--                        label="UTR" box clearable-->
      <!--                        v-model="settlement_details.settlement_reference"></v-text-field>-->
      <!--                  </v-flex>-->
      <!--                </v-flex>-->
      <!--              </v-layout>-->
      <!--            </v-card-text>-->
      <!--            <v-divider></v-divider>-->
      <!--            <v-card-actions>-->
      <!--              <v-spacer></v-spacer>-->
      <!--              <v-btn flat type="reset" small @click="updateSettlementDialog = false; loaders.settlement_loader = false">-->
      <!--                Cancel-->
      <!--              </v-btn>-->
      <!--              <v-btn :loading="loaders.settlement_loader" :disabled="loaders.settlement_loader ||-->
      <!--          settlement_details.settlement_reference == ''"-->
      <!--                     color="primary" small @click="updateSettlement()">Confirm-->
      <!--              </v-btn>-->
      <!--            </v-card-actions>-->

      <!--          </v-form>-->
      <!--        </v-card>-->
      <!--      </v-dialog>-->
      <v-snackbar
          :color="snackbar.color"
          :top="snackbar.top"
          :bottom="snackbar.bottom"
          :left="snackbar.left"
          :right="snackbar.right"
          v-model="snackbar.show"
      >
        {{ snackbar.message }}
        <v-btn dark flat @click.native="snackbar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: "Index",
  components: {
    flatPickr
  },
  watch: {
    pagination: {
      handler() {
        this.getMobData();
      },
    },
    "confirm_settlement_details.settlement_reference": function (val) {
      // if(val == null || val == undefined || val == ''){
      this.show_confirm_amt = 0;
      // }
      // else if(val == ){

      // }
    }

  },
  data() {
    return {
      ticket_data: [],
      pagination: {sortBy: "created_at", descending: true, rowsPerPage: 10},
      total_items: 0,
      selected: [],
      settlement_transaction_ids: [],
      validSettlement: '',
      loaders: {
        ticket_loader: false,
        settlement_loader: false
      },
      settlement_details: {
        settlement_reference: '',
        settlement_payment_status: ''
      },
      confirm_settlement_details: {
        settlement_reference: '',

      },
      headers: [
        {
          text: "Date",
          value: "Date",
          align: "left",
          sortable: false,
        },
        {
          text: "Descriptor Name",
          value: "descriptor_name",
          sortable: false,
        },
        // {
        //   text: "Seller Name",
        //   value: "descriptor_name",
        //   sortable: false,
        // },
        {
          text: "Payment Status",
          value: "payment_status",
          sortable: false,
        },
        {
          text: "Ticket Status",
          value: "ticket_status",
          sortable: false,
        },
        {
          text: "Actual Amount",
          value: "price",
          sortable: false,
        }, {
          text: "Cancellation Charge",
          value: "cancellation",
          sortable: false,
        }, {
          text: "Seller Settlement INR",
          value: "refund",
          sortable: false,
        },
        {
          text: "Settlement Id",
          value: "settlement_id",
          sortable: false,
        },
        {
          text: "Settlement Ref",
          value: "settlement_ref",
          sortable: false,
        }, {
          text: "Reconciliation Id",
          value: "reconciliation_id",
          sortable: false,
        }
      ],
      updateSettlementDialog: false,
      service_provider: "",
      line_id: "",
      transaction_date: moment().format('YYYY-MM-DD'),
      reconcile_transaction_date: moment().format('YYYY-MM-DD'),
      config: {
        enableTime: false,
        altInput: true,
        dateFormat: "Y-m-d",
        time_24hr: false,
        // minDate: moment().subtract(90, 'days').format('YYYY-MM-DD'),
        // maxDate: moment().add(90, 'days').format('YYYY-MM-DD')
      },
      valid: "",
      provider_list: [
        {text: "Kochi Triffy Metro", title: process.env.VUE_APP_KMRL_BPP_ID, mode: 'Metro'},
        {text: "Delhi Metro", title: process.env.VUE_APP_DMRC_BPP_ID, mode: 'Metro'},
        {text: "MMMOCL Metro (METRO 2A & 7)", title: process.env.VUE_APP_MMMOCL_BPP_ID, mode: 'Metro'},
        {text: "MMMOCL Metro (METRO 2A)", title: process.env.VUE_APP_MMMOCL_2A_BPP_ID, mode: 'Metro'},
        {text: "MMMOCL Metro (METRO 7)", title: process.env.VUE_APP_MMMOCL_LINE7_BPP_ID, mode: 'Metro'},
        {text: "MMRCL Metro (METRO L3(AQUA))", title: process.env.VUE_APP_MMRCL_BPP_ID, mode: 'Metro'},
        {text: "MMOPL Metro (METRO Line 1)", title: process.env.VUE_APP_MMOPL_BPP_ID, mode: 'Metro'},
        {text: "Bangalore Metro (BMRCL)", title: process.env.VUE_APP_BMRCL_BPP_ID, mode: 'Metro'},
        {text: "Pune Metro", title: process.env.VUE_APP_PUNE_BPP_ID, mode: 'Metro'},
        {text: "Gujarat Metro", title: process.env.VUE_APP_GUJARAT_BPP_ID, mode: 'Metro'},
        {text: "Mumbai(Bus)", title: process.env.VUE_APP_BUS_MUMBAI_BPP_ID, mode: 'Bus'},
        {text: "Delhi(Bus)", title: process.env.VUE_APP_BUS_DELHI_BPP_ID, mode: 'Bus'},
      ],
      show_confirm_amt: 0,
      no_ticket_dialog: 0,
      confirm_settlement_amt: 0,
      confirm_settlement_ticket_no: 0,
      snackbar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false
      },
      confirm_reconcile_model: false,
      items: [
        {value: "Metro", text: "Metro", icon: "phone"},
        {value: "Bus", text: "Bus", icon: "phone"},
      ],
      tabSelection: "Metro",
    }
  },
  methods: {
    // getMobData() {
    //   this.startLoading()
    //   axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-tickets`, {headers: this.$headers}).then((response) => {
    //     if (response.data.status == 1) {
    //       this.stopLoading();
    //       this.ticket_data = response.data.data;
    //     } else {
    //       this.stopLoading();
    //     }
    //   }).catch((error) => {
    //     this.stopLoading();
    //     this.snackbar.show = true;
    //     this.snackbar.message = "Something Went Wrong";
    //   });
    // },
    // updateSettlement() {
    //   this.selected.forEach((item) => {
    //     this.settlement_transaction_ids.push(item.transaction_id);
    //   });
    //   this.startLoading();
    //   axios.post(`${process.env.VUE_APP_API_URL}/api/v1/update-settlement-details`,
    //       {
    //         settlement_ids: this.settlement_transaction_ids,
    //         settlement_ref: this.settlement_details.settlement_reference
    //       }, {headers: this.$headers})
    //       .then((response) => {
    //         if (response.data.status == 1) {
    //           this.stopLoading();
    //           this.updateSettlementDialog = false;
    //           this.settlement_transaction_ids = [];
    //           this.selected = [];
    //           // this.getMobData();
    //         }
    //       }).catch((error) => {
    //     this.stopLoading();
    //     this.snackbar.show = true;
    //     this.snackbar.message = "Something Went Wrong";
    //   });
    // },
    download1(data) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute('download',
          'Transaction_ToBe_Settled_' + this.transaction_date + '.csv');
      document.body.appendChild(link);
      link.click();
    },
    exportToBeSettledTransactions() {
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/export-tobe-settle-transactions`,
          {transaction_date: this.transaction_date, service_provider: this.service_provider,
            mode: this.tabSelection},
          {headers: this.$headers, responseType: 'blob'})
          .then((response) => {
            this.download1(response.data);
            this.transaction_date = moment().format('YYYY-MM-DD');
            this.service_provider = '';
            this.stopLoading();
          }).catch((error) => {
        this.stopLoading();
        this.snackbar.show = true;
        this.snackbar.message = "Something Went Wrong";
      }).finally(() => {
        this.stopLoading();
      })
    },
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this[scope]();
        }
      });
    },
    getBackendPublicURL(filePath) {
      return `${process.env.VUE_APP_API_URL}/${filePath}`
    },
    importSettlementUTRNumber() {
      this.startLoading();
      var myForm = $('#update_UTR_settlement_' + this.tabSelection)[0];

      let formData = new FormData(myForm);
      formData.append('mode', this.tabSelection);

      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/import-utr-settlement-data`, formData, {headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              const url = this.getBackendPublicURL(response.data.data);

              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', response.data.data);
              document.body.appendChild(link);
              link.click();

              this.downloadLine = '';
              this.downloadDirection = '';
              this.file = '';
              document.getElementById('master_data_file_' + this.tabSelection).value = null;
              this.stopLoading();
            } else {
              this.stopLoading();
              this.headingErrors = response.data.message
              this.headingErrorsShow = true
              document.getElementById('master_data_file_' + this.tabSelection).value = "";
            }
          }).catch((error) => {
        console.log(error);
        this.stopLoading();
        this.snack_bar.message = "Error Occurred";
        this.snack_bar.show;
      })
          .finally(() => {
            this.loading.submit = false
            this.stopLoading()
          })
    },
    confirmSettlement() {
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/get-transaction-amount-by-utr`,
          {UTR_number: this.confirm_settlement_details.settlement_reference},
          {headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              this.show_confirm_amt = 1;

              if (response.data.data.total_price != 0 && response.data.data.total_price != null) {
                this.confirm_settlement_amt = response.data.data.total_price;
              } else {
                this.no_ticket_dialog = 1;
                this.confirm_settlement_amt = 0;
              }
              this.confirm_settlement_ticket_no = response.data.data.total_rows;
              this.stopLoading();
            } else {
              this.stopLoading();
              this.snackbar.show = true;
              this.snackbar.message = response.data.message;
            }
          }).catch((error) => {
        this.stopLoading();
        this.snackbar.show = true;
        this.snackbar.message = "Something Went Wrong";
      }).finally(() => {
        this.stopLoading()
      })
    },
    callReceiverRecon() {
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/invoke-receiver-recon`,
          {UTR_number: this.confirm_settlement_details.settlement_reference, mode: this.tabSelection},
          {headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              this.show_confirm_amt = 0;
              this.confirm_settlement_details.settlement_reference = '';
              this.confirm_settlement_amt = 0;
              this.confirm_settlement_ticket_no = 0;
              this.confirm_reconcile_model = false;
              this.snackbar.show = true;
              this.snackbar.message = response.data.message;
              this.stopLoading();
            } else if (response.data.status == 0) {
              this.confirm_settlement_details.settlement_reference = '';
              this.show_confirm_amt = 0;
              this.confirm_settlement_amt = 0;
              this.confirm_settlement_ticket_no = 0;
              this.confirm_reconcile_model = false;
              this.stopLoading();
              this.snackbar.show = true;
              this.snackbar.message = response.data.message;
            }
          }).catch((error) => {
        this.stopLoading();
        this.confirm_settlement_details.settlement_reference = '';
        this.show_confirm_amt = 0;
        this.confirm_settlement_amt = 0;
        this.confirm_settlement_ticket_no = 0;
        this.confirm_reconcile_model = false;
        this.snackbar.show = true;
        this.snackbar.message = "Something Went Wrong";
      }).finally(() => {
        this.stopLoading()
      })
    },
    download2(data) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute('download',
          'Reconcile_Transaction_Status_' + this.reconcile_transaction_date + '.csv');
      document.body.appendChild(link);
      link.click();
    },
    exportReconcileTransactions() {
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/export-reconcile-transactions`,
          {transaction_date: this.reconcile_transaction_date, mode: this.tabSelection},
          {headers: this.$headers, responseType: 'blob'})
          .then((response) => {
            this.download2(response.data);
            this.reconcile_transaction_date = moment().format('YYYY-MM-DD');
            this.stopLoading();
          }).catch((error) => {
        this.stopLoading();
        this.snackbar.show = true;
        this.snackbar.message = "Something Went Wrong";
      }).finally(() => {
        this.stopLoading();
      })
    },
  },
  mounted() {
    // this.getMobData();
  },
  computed: {
    filteredProviders() {
      return this.provider_list.filter(item =>
          item.mode.includes(this.tabSelection))
    }
  }
}
</script>

<style scoped>

</style>
